import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class WomensBandsSplash extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
    super(props);
    this.state = {

    };
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='WomensBandsSplash'>
      <div className={'wbsTopSection wbsSection'}>
        <div className={'wbCol1 wbImgCol'}></div>
        <div className='wbCol2'>
          <div className='topPromptHeader'>
            <img className='desktop600' src='https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/dainty2.jpg' />
            <img className='mobile600' src='https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/mobile/dainty2_m.jpg' />
          </div>
          <div className='topPromptWrapper'>
            <div className={'promptBox promptTop'}>
              <div className='promptImg'>
                <img src='https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/dainty_prod.png' />
              </div>
              <div className='promptWrapper'>
                <div className='promptTitle'>Dainty Diamond Accents</div>
                <div className='promptCopy'>Take your engagement ring to the next level with enchanting diamond accents that add double the sparkle.</div>
                <div className='promptButton' onClick={() => this.internalNav('jewelry/BLDSM18486')}>Shop This Ring</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={'wbsMidSection wbsSection'}>
        <div className={'wbCol2 wbImgCol mobile600'}></div>
        <div className='wbCol1'>
          <div className='midPromptWrapper'>
            <div className={'promptBox promptMid'}>
              <div className='promptImg'>
                <img src='https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/exquisit_prod.png' />
              </div>
              <div className='promptWrapper'>
                <div className='promptTitle'>Exquisite Details</div>
                <div className='promptCopy'>Intricate milgrain and bezel details give our one-of-a-kind pieces and stunning and vintage touch.</div>
                <div className='promptButton' onClick={() => this.internalNav('jewelry/BLDMD18924')}>Shop This Ring</div>
              </div>
            </div>
          </div>
        </div>
        <div className={'wbCol2 wbImgCol desktop600'}></div>
      </div>
      <div className={'wbsBottomSection wbsSection'}>
        <div className={'wbCol1 wbImgCol'}></div>
        <div className='wbCol2'>
          <div className='bottomPromptWrapper'>
            <div className={'promptBox promptBottom'}>
              <div className='promptImg'>
                <img src='https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/twist_prod.png' />
              </div>
              <div className='promptWrapper'>
                <div className='promptTitle'>Trendy Twists</div>
                <div className='promptCopy'>Calling all trendsetters! Our assortment of unique styles includes this seasons latest fads.</div>
                <div className='promptButton' onClick={() => this.internalNav('jewelry/BLDMD06217')}>Shop This Ring</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='wbsFooter'>
        <img className='desktop600' src='https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/charming.png' />
        <img className='mobile600' src='https://ddw2.diamondsdirect.com/img/gallery/bands/splash/womens/mobile/charming_m.jpg' />
        <div className='footerCopyWrapper'>
          <div className='footerCopyTitle'>Charming Classics</div>
          <div className='footerCopyBody'>For a timeless look, classic diamond wedding bands are the perfect balance of simple yet dazzling.</div>
          <div className='footerCopyButton' onClick={() => this.internalNav('jewelry/BLDMD21500')}>Shop This Ring</div>
        </div>
      </div>
		</div>;
	}
}
export default WomensBandsSplash;

function mapStateToProps(state) {
  return {

  };
}

export const WomensBandsSplashContainer = connect(
  mapStateToProps,
  allActionCreators
)(WomensBandsSplash);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/splash/WomensBandsSplash.jsx